import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  qtyToTransferColumnHeader: {
    defaultMessage: 'Qty to Transfer',
    id: 'TAsQcJ',
    description: 'Column header for quantity to transfer',
  },
  unitOfMeasure: {
    id: 'ZbhrRq',
    defaultMessage: 'UoM',
    description: 'Unit of measure column header in readonly product grid',
  },
  eaches: {
    id: '3pcsVC',
    defaultMessage: 'Eaches',
    description: 'Eaches column header in readonly product grid',
  },
});
